import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpOptions, HttpService } from './../../../utils';
import { assertDependency, isAssertOn } from './../../internal/assert';
import { createHttpServiceOnHttpClient } from './../../utils/http.service.on.http.client';
import { assign } from './../../utils/js.utils';

/* Copyright IBM Corp. 2017 */
@Injectable({ providedIn: 'root' })
export class HttpServiceOnHttpClient implements HttpService {

    // interface implementation
    getJson: <T>(aUrl: string, aOptions: HttpOptions) => Observable<T>;
    getText: (aUrl: string, aOptions: HttpOptions) => Observable<string>;

    constructor(aHttpClient: HttpClient) {
        // validate the dependencies
        if (isAssertOn()) {
            // assert our dependencies
            assertDependency(aHttpClient, 'HttpClient');
        }
        // override
        assign(this, createHttpServiceOnHttpClient(aHttpClient));
    }
}
